import { Phone, MessageCircle, Mail } from "lucide-react";

interface AnsprechpartnerCardProps {
  name: string;
  title: string;
  subtitle: string;
  imageSrc: string;
  phone: string;
  phoneDisplay: string;
  email?: string;
  whatsapp?: string;
  testId?: string;
}

export default function AnsprechpartnerCard({
  name,
  title,
  subtitle,
  imageSrc,
  phone,
  phoneDisplay,
  email,
  whatsapp,
  testId,
}: AnsprechpartnerCardProps) {
  return (
    <div
      className="bg-neko-dark-2 border border-neko-dark-3 rounded-xl p-4 mb-4"
      data-testid={testId}
    >
      <div className="flex items-center gap-4 mb-3">
        <img
          src={imageSrc}
          alt={name}
          className="w-14 h-14 rounded-full object-cover border-2 border-neko-orange/40"
        />
        <div>
          <p className="text-neko-white font-medium">{name}</p>
          <p className="text-xs text-neko-gray">{title}</p>
          <p className="text-xs text-neko-orange mt-0.5">{subtitle}</p>
        </div>
      </div>
      <div className="flex gap-2">
        {whatsapp && (
          <a
            href={`https://wa.me/${whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 bg-neko-green/15 text-neko-green border border-neko-green/30 font-medium py-2 px-3 rounded-lg text-sm hover:bg-neko-green/25 transition-all"
          >
            <MessageCircle className="w-4 h-4" />
            WhatsApp
          </a>
        )}
        {email && (
          <a
            href={`mailto:${email}`}
            className="flex-1 flex items-center justify-center gap-2 bg-neko-dark-3 text-neko-white border border-neko-dark-3 font-medium py-2 px-3 rounded-lg text-sm hover:bg-neko-gray/20 transition-all"
          >
            <Mail className="w-4 h-4" />
            E-Mail
          </a>
        )}
        <a
          href={`tel:${phone}`}
          className="flex items-center justify-center gap-2 bg-neko-dark-3 text-neko-gray border border-neko-dark-3 font-medium py-2 px-3 rounded-lg text-sm hover:text-neko-white hover:bg-neko-gray/20 transition-all"
          title={phoneDisplay}
        >
          <Phone className="w-4 h-4" />
          <span className="hidden sm:inline">{phoneDisplay}</span>
        </a>
      </div>
    </div>
  );
}
